import { render, staticRenderFns } from "./TargetsV2.vue?vue&type=template&id=159767e2&scoped=true&lang=pug&"
import script from "./TargetsV2.vue?vue&type=script&lang=js&"
export * from "./TargetsV2.vue?vue&type=script&lang=js&"
import style0 from "./TargetsV2.vue?vue&type=style&index=0&id=159767e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159767e2",
  null
  
)

export default component.exports